import { loadScript } from '@/utils/load-script'
export default function vconsole() {
  loadScript('//shared.ydstatic.com/ydkids/libs/vconsole-3.12.1.min.js').then(
    () => {
      const vconsole = new window.VConsole()
    }
  )
}
